import { createSlice } from '@reduxjs/toolkit'

const initialState = {
    allAcademicYearListLoading: false,
    allAcademicYearListSuccess: null,
    allAcademicYearListError: '',

    getAcademicYearLoading: false,
    getAcademicYearSuccess: null,
    getAcademicYearError: '',

    createAdademicYearLoading: false,
    createAdademicYearSuccess: {},
    createAdademicYearError: '',

   
}

export const academicYearSlice = createSlice({
    name: 'academicYear',
    initialState,
    reducers: {
        setAcademicYearListLoading: (state) => {
            state.allAcademicYearListLoading = true;
            state.allAcademicYearListSuccess = null;
            state.allAcademicYearListError = '';
        },
        setAcademicYearListSuccess: (state, action) => {
            state.allAcademicYearListLoading = false;
            state.allAcademicYearListSuccess = action.payload;
            state.allAcademicYearListError = '';
        },
        setAcademicYearListError: (state, action) => {
            state.allAcademicYearListLoading = false;
            state.allAcademicYearListSuccess = null;
            state.allAcademicYearListError = action.payload;
        },
        setAcademicYrDetailsLoading: (state) => {
            state.getAcademicYearLoading = true;
            state.getAcademicYearSuccess = {};
            state.getAcademicYearError = '';
        },
        setAcademicYrDetailsSuccess: (state, action) => {
            state.getAcademicYearLoading = false;
            state.getAcademicYearSuccess = action.payload;
            state.getAcademicYearError = '';
        },
        setAcademicYrDetailsError: (state, action) => {
            state.getAcademicYearLoading = false;
            state.getAcademicYearSuccess = {};
            state.getAcademicYearError = action.payload;
        },

        setCreateAdademicYearLoading: (state) => {
            state.createAdademicYearLoading = true;
            state.createAdademicYearSuccess = {};
            state.createAdademicYearError = '';
        },
        setCreateAdademicYearSuccess: (state, action) => {
            state.createAdademicYearLoading = false;
            state.createAdademicYearSuccess = action.payload;
            state.createAdademicYearError = '';
        },
        setCreateAdademicYearError: (state, action) => {
            state.createAdademicYearLoading = false;
            state.createAdademicYearSuccess = {};
            state.createAdademicYearError = action.payload;
        },


        resetDetails: (state) => {
            state.getAcademicYearSuccess = {};
            state.createAdademicYearSuccess = {};
            state.getFeedbackDetailsSuccess = {};
        },
    }
})

export const { setAcademicYearListLoading, setAcademicYearListSuccess, setAcademicYearListError,
    setAcademicYrDetailsLoading, setAcademicYrDetailsSuccess, setAcademicYrDetailsError,

    setCreateAdademicYearLoading, setCreateAdademicYearSuccess, setCreateAdademicYearError,
    resetDetails
} = academicYearSlice.actions;


export default academicYearSlice.reducer;